import LeaderboardAnalytics from './LeaderboardAnalytics';

export default LeaderboardAnalytics;
